import { PlanType } from "@/types/PlanTypes";
import { Highlighter } from "@/ui/Highlighter";
import { useAppPathname } from "@/routing/navigation";
import DrawerCollapse from "../NavMenu/DrawerCollapse";
import { isPlanSectionActive, planPages, type PlanKey } from "./navItems";

/**
 * A product's section of the sidebar. Showing a product's pages already says
 * it is active, so its pages carry no ACTIVE chip, and Endpoint Generator is
 * not new any more; the one status the sidebar shows is INACTIVE, on the
 * pricing page of a product without a plan (R-2295).
 */
export function PlanCollapse({
  title,
  icon,
  autoCloseDrawer,
  plan,
  planKey,
}: {
  title: string;
  icon: string;
  autoCloseDrawer: () => void;
  plan: PlanType | undefined;
  planKey: PlanKey;
}) {
  const pathname = useAppPathname();
  // The section must open for the inactive slot's pricing page too (R-2200).
  const isActive = isPlanSectionActive(pathname, plan, planKey);

  const items = planPages(plan, planKey).map((item) =>
    plan
      ? item
      : {
          ...item,
          status: (
            <Highlighter size="small" innerVariant="opacity" severity="default">
              INACTIVE
            </Highlighter>
          ),
        }
  );

  return (
    <DrawerCollapse
      isOpen={isActive}
      title={title}
      icon={
        <img
          loading="lazy"
          decoding="async"
          alt={title}
          src={icon}
          width={24}
          height={24}
        />
      }
      items={items}
      autoCloseDrawer={autoCloseDrawer}
    />
  );
}
